<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-sm-8">
          <h4 class="mb-0">PM V2 - جزئیات تجهیز</h4>
        </div>
        <div class="col-sm-4 text-left"><button type="button" class="btn btn-warning" (click)="Back()"><i
              class="fa fa-mail-reply"></i> بازگشت</button></div>
      </div>

      <div class="card card-statistics mb-30" *ngIf="Context as context">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4"><strong>تجهیز:</strong> {{ context.Equipment_Name || '-' }} <small>{{
                context.Equipment_Model || '' }}</small></div>
            <div class="col-md-3"><strong>کد تجهیز:</strong> {{ context.Equipment_Code || '-' }}</div>
            <div class="col-md-5"><strong>قالب :</strong> {{ context.Template_Code }} - {{ context.Template_Name }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="Procssing" class="text-center p-3">در حال دریافت اطلاعات...</div>
      <div class="table-responsive" *ngIf="!Procssing">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color:#489b39;color:white">
            <tr>
              <th>#</th>
              <th>فعالیت</th>
              <th>دوره</th>
              <th>آخرین PM</th>
              <th>سررسید</th>
              <th>وضعیت</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList; let i=index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.Activity_Name }}</td>
              <td>{{ item.Frequency != null ? item.Frequency + ' روز' : '-' }}</td>
              <td>{{ item.Last_PM_Date_Persian || '-' }}</td>
              <td>{{ item.Next_PM_Date_Persian || '-' }}</td>
              <td><span class="badge" [ngClass]="StatusClass(item)">{{ Status(item) }}</span></td>
              <td><button type="button" class="btn btn-success" [disabled]="!item.Can_Execute"
                  (click)="Execute(item)">ثبت اجرا</button></td>
            </tr>
            <tr *ngIf="DataList.length === 0">
              <td colspan="7">آیتم فعال PM برای این تجهیز وجود ندارد.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card card-statistics mt-4 mb-30">
        <div class="card-header"><strong>تاریخچه اجرای PM</strong></div>
        <div class="card-body">
          <div *ngIf="HistoryProcessing" class="text-center p-3">در حال دریافت تاریخچه...</div>
          <div class="table-responsive" *ngIf="!HistoryProcessing">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color:#489b39;color:white">
                <tr>
                  <th>فعالیت</th>
                  <th>سررسید</th>
                  <th>تاریخ اجرا</th>
                  <th>نتیجه</th>
                  <th>مقدار عددی</th>
                  <th>مقدار متنی</th>
                  <th>توضیحات</th>
                  <th>انجام‌دهنده</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let history of HistoryList| paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 20,
                        currentPage: page,
                        totalItems: HistoryList.length
                      };">
                  <td>{{ history.Activity_Name || '-' }}</td>
                  <td>{{ history.Date_Due_Persian || '-' }}</td>
                  <td>{{ history.Date_Execution_Persian || '-' }}</td>
                  <td><span class="badge"
                      [ngClass]="history.Result === 'Pass' ? 'badge-success' : history.Result === 'Fail' ? 'badge-danger' : 'badge-secondary'">{{
                      history.Result || '-' }}</span></td>
                  <td>{{ history.Numeric_Value != null ? history.Numeric_Value : '-' }}</td>
                  <td>{{ history.Text_Value || '-' }}</td>
                  <td>{{ history.Description || '-' }}</td>
                  <td>{{ history.Performer_Name || '-' }}</td>
                </tr>
                <tr *ngIf="HistoryList.length === 0">
                  <td colspan="8">سابقه‌ای ثبت نشده است</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی"
          (pageChange)="page = $event">
        </pagination-controls>
      </div>
    </div>
  </div>
</div>